module.exports = __webpack_public_path__ + "img/milestone__2006.c60740ef.jpg";